import Vue from 'vue';

const getClientId = () => {
    if (window.location.host.includes(process.env.VUE_APP_BUNGE_URL)) {
        return process.env.VUE_APP_KEYCLOAK_BUNGE_CLIENT_ID;
    }
    return process.env.VUE_APP_KEYCLOAK_CLIENT_ID;
};

const getUrls = () => {
    const urls = new Map();
    urls.set('development', 'http://localhost:8080/#/');
    urls.set('staging', 'https://dev.vegamonitoramento.com.br/lyra/v1/#/');
    urls.set('e2e', 'https://dev.vegamonitoramento.com.br/lyra/v1/#/');
    urls.set('homolog', 'https://homologacao.vegamonitoramento.com.br/lyra/v1/#/');
    urls.set('production', 'https://lyra.vegamonitoramento.com.br/v1/');
    return urls;
};

const getUrlsBunge = () => {
    const urlsBunge = new Map();
    urlsBunge.set('development', 'http://localhost:8080/#/');
    urlsBunge.set('staging', 'https://dev.vegamonitoramento.com.br/bunge/v1/#/');
    urlsBunge.set('e2e', 'https://dev.vegamonitoramento.com.br/bunge/v1/#/');
    urlsBunge.set('homolog', 'http://sistemas.vegamonitoramento.com.br/bunge/');
    urlsBunge.set('production', 'http://parceriasustentavel.bunge.com.br/');
    return urlsBunge;
};

const getLogoutUrl = () => {
    let idToken = sessionStorage.getItem('idToken');
    let ambiente = process.env.NODE_ENV;

    if (window.location.host.includes(process.env.VUE_APP_BUNGE_URL)) {
        return `${process.env.VUE_APP_KEYCLOAK_BUNGE_LOGOUT_URL}?id_token_hint=${idToken}&post_logout_redirect_uri=${getUrlsBunge().get(ambiente)}`;
    }

    return `${process.env.VUE_APP_KEYCLOAK_LOGOUT_URL}?id_token_hint=${idToken}&post_logout_redirect_uri=${getUrls().get(ambiente)}`;
};

const getKeycloakInstance = () => {
    return Vue.prototype.keycloak;
};

const getTokenTimeExp = () => {
    return Math.round(getKeycloakInstance().tokenParsed.exp + getKeycloakInstance().timeSkew - new Date().getTime() / 1000);
};

export default {
    getClientId,
    getLogoutUrl,
    getUrls,
    getUrlsBunge,
    getKeycloakInstance,
    getTokenTimeExp
};
